import { getAuth as _getAuth } from 'firebase/auth';
import { getApp } from './getApp.ts';

export const getAuth = () => _getAuth(getApp());
